import { defineComponent } from 'vue-demi';
import { openBlock, createElementBlock, normalizeClass, createTextVNode, toDisplayString, Fragment, renderList, createElementVNode, createCommentVNode, pushScopeId, popScopeId } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

function isEmpty(val) {
  return val == null || !(Object.keys(val) || val).length;
}

var LoaderViews;
(function (LoaderViews) {
  LoaderViews["default"] = "default";
  LoaderViews["text"] = "text";
  LoaderViews["linear"] = "linear";
})(LoaderViews || (LoaderViews = {}));

var script = defineComponent({
  name: 'OrLoader',
  props: {
    type: {
      type: String,
      default: LoaderViews.default,
      required: false
    },
    textTypeLabel: {
      type: String,
      default: null,
      required: false
    },
    linearTitle: {
      type: String,
      default: '',
      required: false
    },
    linearDescription: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    rootClasses() {
      return ['or-loader', `is-${this.type}`];
    },
    isTextType() {
      return this.type === LoaderViews.text;
    },
    isLinearType() {
      return this.type === LoaderViews.linear;
    },
    isEmptyLinearDescription() {
      return isEmpty(this.linearDescription);
    },
    isEmptyLinearTitle() {
      return isEmpty(this.linearTitle);
    }
  }
});

const _withScopeId = n => (pushScopeId("data-v-77c2a898"), n = n(), popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["textContent"];
const _hoisted_3 = {
  key: 1,
  class: "or-loader--linear"
};
const _hoisted_4 = {
  key: 0,
  class: "or-loader--linear-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/createElementVNode("span", {
  class: "or-loader--linear-loader"
}, [/*#__PURE__*/createElementVNode("span")], -1 /* HOISTED */));
const _hoisted_6 = {
  key: 1,
  class: "or-loader--linear-desc"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", {
    class: normalizeClass(_ctx.rootClasses)
  }, [_ctx.isTextType ? (openBlock(), createElementBlock("span", _hoisted_1, [createTextVNode(toDisplayString(_ctx.textTypeLabel || 'Loading') + " ", 1 /* TEXT */), (openBlock(), createElementBlock(Fragment, null, renderList(3, i => {
    return createElementVNode("span", {
      key: i,
      class: "or-loader--dot",
      textContent: toDisplayString('.')
    }, null, 8 /* PROPS */, _hoisted_2);
  }), 64 /* STABLE_FRAGMENT */))])) : createCommentVNode("v-if", true), _ctx.isLinearType ? (openBlock(), createElementBlock("span", _hoisted_3, [!_ctx.isEmptyLinearTitle ? (openBlock(), createElementBlock("span", _hoisted_4, toDisplayString(_ctx.linearTitle), 1 /* TEXT */)) : createCommentVNode("v-if", true), _hoisted_5, !_ctx.isEmptyLinearDescription ? (openBlock(), createElementBlock("span", _hoisted_6, toDisplayString(_ctx.linearDescription), 1 /* TEXT */)) : createCommentVNode("v-if", true)])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-77c2a898 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-77c2a898 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n@keyframes loaderLinear-77c2a898 {\n0% {\n    transform: translate(-100%, 0);\n}\n100% {\n    transform: translate(100%, 0);\n}\n}\n.or-loader[data-v-77c2a898] {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.or-loader.is-default[data-v-77c2a898]::after {\n  width: 1.5rem;\n  height: 1.5rem;\n  color: var(--c-primary);\n  content: \"\";\n  border-color: inherit;\n  border-top: 2px solid currentColor;\n  border-right: 2px solid currentColor;\n  border-bottom: 2px solid transparent !important;\n  border-left: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spinAround-77c2a898 0.7s linear infinite;\n  transition-timing-function: var(--t-func);\n  transition-duration: var(--t-duration);\n  transition-property: color;\n}\n.or-loader.is-text[data-v-77c2a898] {\n  color: currentColor;\n}\n.or-loader.is-text > span[data-v-77c2a898] {\n  display: inline-flex;\n}\n.or-loader.is-text .or-loader--dot[data-v-77c2a898]:nth-child(0) {\n  animation: fade-77c2a898 1s var(--t-func) 0s infinite;\n}\n.or-loader.is-text .or-loader--dot[data-v-77c2a898]:nth-child(1) {\n  animation: fade-77c2a898 1s var(--t-func) 0.2s infinite;\n}\n.or-loader.is-text .or-loader--dot[data-v-77c2a898]:nth-child(2) {\n  animation: fade-77c2a898 1s var(--t-func) 0.4s infinite;\n}\n.or-loader.is-text .or-loader--dot[data-v-77c2a898]:nth-child(3) {\n  animation: fade-77c2a898 1s var(--t-func) 0.6s infinite;\n}\n.or-loader.is-linear[data-v-77c2a898] {\n  width: 100%;\n}\n.or-loader.is-linear .or-loader--linear[data-v-77c2a898] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.or-loader.is-linear .or-loader--linear-title[data-v-77c2a898] {\n  margin-bottom: var(--s-4);\n  font-size: var(--fs-2);\n  font-weight: bold;\n  color: var(--c-neutral-6);\n  letter-spacing: -0.45px;\n}\n.or-loader.is-linear .or-loader--linear-loader[data-v-77c2a898] {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 0.25rem;\n  overflow: hidden;\n  background-color: var(--c-neutral-2);\n  border-radius: 0.125rem;\n}\n.or-loader.is-linear .or-loader--linear-loader > span[data-v-77c2a898] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  animation: loaderLinear-77c2a898 1.2s var(--t-func) infinite;\n}\n.or-loader.is-linear .or-loader--linear-loader > span[data-v-77c2a898]::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  max-width: 7rem;\n  height: 100%;\n  content: \"\";\n  background-color: var(--c-primary);\n  border-radius: 0.125rem;\n}\n.or-loader.is-linear .or-loader--linear-desc[data-v-77c2a898] {\n  margin-top: var(--s-4);\n  color: var(--c-neutral-5);\n  text-align: center;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-77c2a898";
script.__file = "src/components/or-loader/OrLoader.vue";

export { LoaderViews as L, isEmpty as i, script as s };
